namespace advisorop.domains {
    "use strict";

    export interface IDmsDocument {
        id?: number;
        documentName?: string;
        extension?: string;
        dateCreated?: Date;
        dateChanged?: Date;
        version?: number;
        versions?: number;
        documentType?: number;
        signedDocumentType?: boolean
        documentTypeDesc?: string;
        enableDisableStatus?: string;
        documentDate?: Date;
        documentDescription?: string;
        documentRelation?: domains.DocumentRelation;
        relationId?: number;
        relationDescription?: string;
        laserAppFormId?: number;
        laserAppFormNumber?: string;
        esignatureGroup?: IESignatureGroup[];
        latestEsignatureIdentifierString?: string;
        latestEsignatureStatus?: string;
        latestEsignatureUpdate?: Date;
        latestEsignatureSystem?: domains.ExternalSystem;
        uploadedToCustodian?: Date;

        // local client-side variables
        addToESignature?: boolean;
        sendToCustodian?: boolean;
    }

    export interface IESignatureBulkSetupModel {
        eSigDocumentGroupSettings: domains.IESigDocumentGroupSettings;
        eSigDocumentGroupDocuments: domains.IESigDocumentGroupDocuments[];
    }

    export interface IESigDocumentGroupSettings {
        eSignatureSystem: ExternalSystem;
        includeFormCRS: boolean;
    }

    export interface IESigDocumentGroupDocuments {
        docsToSend: IDmsDocumentKey[];
    }

    export interface IDmsDocumentKey {
        documentRelation: domains.DocumentRelation;
        accountId?: number;
        investorId?: number;
        documentId: number;
        version: number;
    }

    export interface IESignatureGroup {
        id?: number;
        eSigDocumentGroupId?: string;
        eSigDocumentGroupStatus?: string;
        lastUpdateDate?: Date;
    }

    // structure containing form guid and document type sent to server when generating laserapp forms
    export interface ILaserAppGenRequest {
        formGuid: string;
        documentType: DocumentType;
    }
}
